import { fileImgName } from "@/utils/avatar";

export function getFileIcon(fileName, type, contentType = "") {
    if (contentType == "DOCUMENT") {
        return "cloud-online-doc";
    }
    if (type !== "0") return "cloud-folder";
    const name = fileName.trim();
    const index = name.lastIndexOf(".");
    if (index === -1) return "cloud-other";
    const ext = name
        .substr(index)
        .replace(".", "")
        .toLowerCase();
    return fileImgName(ext);
}